module.exports = __webpack_public_path__ + "media/townhomes.6adb8f96.png";